// extracted by mini-css-extract-plugin
module.exports = {"subrow":"client-log-details_subrow_E0EbZ"};